<template>
    <div>
        <v-row v-if="isHeader()">
            <v-col cols="12" class="header" :class="field.weight > 1 ? 'add-header' : ''">{{ field.value }}</v-col>
        </v-row>
        <v-row v-else-if="isInputField()" class="customfield-row">
            <v-col cols="5" class="label bold date-label">
                {{ field.label }}
            </v-col>
            <v-col cols="7" class="input" v-if="isString()" align-self="center">
                <input type="text" :required="field.required" v-model="value" @change="updateValue" :name="field.name" :placeholder="placeholder">
            </v-col>
            <v-col cols="7" class="input" v-else-if="isText()" align-self="center">
                <textarea :required="field.required" v-model="value" @change="updateValue" :name="field.name" :placeholder="placeholder"></textarea>
            </v-col>
            <v-col cols="7" class="input" v-else-if="isInteger()" align-self="center">
                <input type="number" :required="field.required" v-model="value" @change="updateValueNumber" :name="field.name">
            </v-col>
        </v-row>
        <v-row v-else-if="isCheckbox()" class="checkbox customfield-row">
            <v-col cols="12" class="input">
                <label class="checkbox-label">
                    <input type="checkbox" :required="field.required" v-model="value" class="checkbox-input" @change="updateValueBoolean" :name="field.name">
                    {{ field.label }}
                </label>
            </v-col>
        </v-row>
        <v-row v-else-if="isSelect()" class="customfield-row">
            <v-col cols="5" class="label bold date-label">
                {{ field.label }}
            </v-col>
            <v-col cols="7" class="input" align-self="center">
                <select v-model="value" @change="updateValue" :name="field.name" :required="field.required">
                    <option v-for="option in selectOptions" :key="option">{{ option }}</option>
                </select>
            </v-col>
        </v-row>
        <div v-else-if="isOkActionNote()" class="ok-action-field">
            <div>
                <div class="control-group">
                    <label class="label bold control-label" style="margin-left:5px;">{{ field.label }}</label>
                    <div class="controls">
                        <div class="form-inline control-field" style="width: 97%;margin-left:5px;">
                            <label class="label bold" style="margin-right: 10px; display: inline-block;">
                                <input type="checkbox" :id="okActionOkId" name="field.name" @change="updateOkActionValue($event)" value="ok" ref="ok" :checked="okChecked">
                                OK
                            </label>
                            <label class="label bold" style="display: inline-block">
                                <input type="checkbox" :id="okActionActionId" :name="field.name" @change="updateOkActionValue($event)" value="action" ref="action" :checked="actionChecked">
                                Åtgärd
                            </label>
                            <input type="text" :id="okActionCommentId" :placeholder="placeholder + ' Kommentar'" :required="field.required" style="width: 97%;" v-model="comment" @change="updateOkActionValue($event)">
                        </div>
                    </div>
                </div>
            </div>
            <hr>
        </div>
        <div v-else-if="isDate()" class="date-picker">
            <v-menu v-model="show"
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="value"
                        :label="field.label"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on">
                    </v-text-field>
                </template>
                <v-date-picker
                    :first-day-of-week="1"
                    flat
                    locale="sv-SE"
                    light
                    no-title
                    v-model="value"
                    @change="updateValueDate(value)"
                    :name="field.name"
                ></v-date-picker>
            </v-menu>
        </div>
        <div v-else-if="isButton()"></div>
        <div v-else>
            New kind of custom field detected. Needs to be implemented
        </div>
    </div>
</template>

<script>

export default {
    name: 'Customfield',
    props: {
        field: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: false
        },
        yearlyInspection: {
            type: Boolean,
            required: false
        }
    },
    mounted() {
        if (this.isDate() && !this.value) {
            if (this.field.value && this.yearlyInspection && this.field.name == 'senastebesiktad') {
                let fieldValue = this.field.value.toString();
                this.value = fieldValue.indexOf('-') > 0 ? this.field.value : new Date(parseInt(this.field.value)).toISOString().substring(0,10);
            } else if (this.field.name != 'garantidatum' && this.field.name != 'installationsdatum') {
                let today = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0,10);
                this.value = today;
                this.updateValueDate(today);
            } else {
                this.value = this.field.value;
            }
        }
        if (this.field && this.field.value && (this.isInputField() || this.isSelect())) {
            this.value = this.field.value;
        }
    },
    data: () => ({
        value: null,
        comment: null,
        show: false,
    }),
    methods: {
        isHeader() { return this.field.type == 'HEADER' },
        isInputField() { return ['STRING', 'TEXT', 'INTEGER'].includes(this.field.type) },
        isDate() { return this.field.type == 'DATE' },
        isString() { return this.field.type == 'STRING' },
        isText() { return this.field.type == 'TEXT' },
        isCheckbox() { return this.field.type == 'CHECKBOX' },
        isInteger() { return this.field.type == 'INTEGER' },
        isSelect() { return this.field.type == 'SELECT' },
        isOkActionNote() { return this.field.type == 'OK_ACTION_NOTE' },
        isButton() { return this.field.type == 'BUTTON' },

        updateValue() { this.$emit('update:value', this.value + (this.comment ? '|' + this.comment : '')) },
        updateOkActionValue() {
            let value = '';
            let okCheckbox = document.getElementById(this.$refs.ok.id);
            let actionCheckBox = document.getElementById(this.$refs.action.id);
            if (okCheckbox && okCheckbox.checked) value = 'ok';
            if (actionCheckBox && actionCheckBox.checked) value = value == 'ok' ? value + '_action' : 'action';
            this.$emit('update:value',  value + (this.comment ? '|' + this.comment : ''));
            },
        updateValueNumber() { this.$emit('update:value', this.value.toString()) },
        updateValueBoolean() { this.$emit('update:value', this.value ? 'true' : 'false' ) },
        updateValueDate(value) { this.$emit('update:value', value) }
    },
    computed: {
        selectOptions() { return this.field.typeInfo && this.field.typeInfo.split('\n'); },
        okActionOkId() { return this.index + 'ok-action-ok'; },
        okActionActionId() { return this.index + 'ok-action-action'; },
        okActionCommentId() { return this.index + 'ok-action-comment'; },
        placeholder() { return this.field.required ? 'Tvingande' : ''; },
        okChecked() {
            return this.field && this.field.value && this.field.value.includes('ok');
        },
        actionChecked() {
            return this.field && this.field.value && this.field.value.includes('action');
        },
    }
}

</script>

<style lang="scss" scoped>
.header {
    font-size: 18px;
    font-weight: bold;
    background-color: #cfcfcf;
    margin: 10px 5px;
    padding: 5px 10px;
}
.label {
    text-align: right;
    font-size: 14px;
    word-wrap: break-word;
    padding: 2px;
}
.input {
    padding: 2px;
}
input, textarea, select {
    border: 1px solid #ccc;
    margin-left: 5px;
    width: 95%;
    line-height: 20px;
}
.date {
    width: 120px;
    text-align: center;
}
.customfield-row {
    margin-top: 4px;
    margin-bottom: 4px;
    width: 340px;
    margin-left: 5px;
}
.date-picker {
    margin-top: 12px;
    margin-bottom: 4px;
    margin-left: 40px;
    width: 300px;
}
.add-header {
    margin-top: 20px;
    margin-bottom: 20px;
}
.checkbox-label {
    width: 100%;
    float: left;
    display:block;
    text-align: left;
}
.checkbox-input {
    margin-right: 10px;
    width: 30px;
    float: left;
}
.checkbox {
    margin-left: 30px;
}
.ok-action-field {
    margin-bottom: 20px;
    margin-top: 10px;
    margin-right: 10px;
    margin-left: 10px;
}
.control-group, .control-label {
    margin-bottom: 5px;
}
.control-label {
    float: none;
    width: auto;
    padding-top: 0;
    text-align: left;
    display: block;
}
.controls {
    width: 100%;
}
.form-inline {
    display: inline-block;
    vertical-align: top;
}
.control-field {
    margin-bottom: 5px;
    font-size: 14px;
    line-height: 20px;
}

</style>